export default {
  tooltip: {
    running: 'Cancel process',
    error: 'View error info',
    clear: 'Clear completed jobs'
  },
  geocode: {
    status: {
      success: 'Table geocoded successfully',
      failure: 'Geocoding error. {link}',
      running: 'Geocoding table…'
    },
    tooltip: {
      success: 'View geocoded table'
    },
    error: {
      title: 'Geocoding table error',
      general: 'It seems that there was a problem geocoding the table and your request could not be completed.',
      info: 'Error info'
    },
    cancel: {
      title: 'Cancel processing job',
      question: 'Do you want to cancel this process?',
      confirm: 'Yes, cancel process',
      continue: 'No, continue'
    },
    customQuery: 'Custom Geocode creation'
  },
  optimize: {
    status: {
      success: 'Table optimized successfully',
      failure: 'Optimization error. {link}',
      running: 'Optimizing table…'
    },
    tooltip: {
      success: 'View optimized table'
    },
    error: {
      title: 'Table optimization error',
      general: 'It seems that there was a problem optimizing the table and your request could not be completed.',
      info: 'Error info'
    },
    cancel: {
      title: 'Cancel processing job',
      question: 'Do you want to cancel this process?',
      confirm: 'Yes, cancel process',
      continue: 'No, continue'
    },
    customQuery: 'Custom Optimization creation'
  },
  prepare: {
    status: {
      success: 'Table prepared successfully',
      failure: 'Preparation error. {link}',
      running: 'Preparing table…'
    },
    tooltip: {
      success: 'View prepared table'
    },
    error: {
      title: 'Table preparation error',
      general: 'It seems that there was a problem preparing the table and your request could not be completed.',
      info: 'Error info'
    },
    cancel: {
      title: 'Cancel processing job',
      question: 'Do you want to cancel this process?',
      confirm: 'Yes, cancel process',
      continue: 'No, continue'
    },
    customQuery: 'Custom Preparation creation'
  },
  export: {
    tab: 'Exports',
    status: {
      success: 'Dataset exported successfully',
      failure: 'Dataset export error. {link}',
      failureInline: 'Dataset export error',
      running: 'Exporting dataset…'
    },
    tooltip: {
      success: 'Download exported data'
    },
    error: {
      title: 'Dataset export error',
      general: 'It seems that there was a problem exporting the dataset and your request could not be completed.',
      info: 'Error info',
      access:
        "It seems your connection doesn't have enough permissions to export a dataset at the output destination (or it doesn't exist). Read more in our {documentationLink}"
    },
    cancel: {
      title: 'Cancel exporting job',
      question: 'Do you want to cancel this process?',
      confirm: 'Yes, cancel process',
      continue: 'No, continue'
    },
    customQuery: 'Custom export creation',
    formats: {
      csv: 'CSV',
      geojson: 'GeoJSON',
      shapefile: 'Shapefile',
      geoparquet: 'GeoParquet',
      geopackage: 'GeoPackage',
      kml: 'KML'
    }
  },
  layerExport: {
    status: {
      success: 'Layer exported successfully.',
      failure: 'Layer export error. <readMoreLink>Read more</readMoreLink>',
      canceled: 'Canceled',
      running: 'Exporting layer…'
    },
    download: {
      title: 'Download data',
      noFilesInfo:
        'The export didn’t produce any file. Please make sure that the layer contains data in the current viewport.'
    }
  },
  dataExport: {
    status: {
      success: 'Data exported successfully. <downloadLink>Download</downloadLink>',
      failure: 'Data export error. <readMoreLink>Read more</readMoreLink>',
      canceled: 'Canceled',
      running: 'Exporting data...'
    },
    download: {
      title: 'Download data'
    },
    error: {
      title: 'Error exporting data',
      message: 'It seems that there was a problem exporting the data and your request could not be completed.'
    },
    cancel: {
      title: 'Cancel export',
      question: 'Do you want to cancel export process of <strong>{name}</strong>?',
      confirm: `Yes, cancel export`,
      continue: 'No, continue',
      notificationSuccess: 'Export canceled successfully.',
      notificationFailed: 'Failed to cancel export.'
    }
  },
  workflowDataExport: {
    status: {
      success: 'Data exported successfully',
      failure: 'Data export error. <readMoreLink>Read more</readMoreLink>',
      canceled: 'Canceled',
      running: 'Exporting data…'
    },
    download: {
      title: 'Download data',
      message:
        'Layer <strong>{name}</strong> exported successfully. Download the files by clicking on the links below.',
      noFilesInfo: 'The export didn’t produce any file. '
    },
    error: {
      title: 'Data export error',
      message: 'It seems that there was a problem exporting the data and your request could not be completed.'
    },
    cancel: {
      title: 'Cancel export',
      question: 'Do you want to cancel export process of <strong>{name}</strong>?',
      confirm: `Yes, cancel export`,
      continue: 'No, continue',
      notificationSuccess: 'Export canceled successfully.',
      notificationFailed: 'Failed to cancel export.'
    }
  },
  activityDataExport: {
    status: {
      success: 'Data exported successfully. <downloadLink>Download</downloadLink>',
      failure: 'Data export error. <readMoreLink>Read more</readMoreLink>',
      canceled: 'Canceled',
      running: 'Exporting activity data…'
    },
    download: {
      title: 'Download activity data',
      categories: {
        activity: 'Activity logs and API usage',
        additionalData: 'Additional data'
      },
      info: 'Find a complete reference and examples on using this data in our <documentationLink>documentation</documentationLink>.'
    },
    error: {
      title: 'Activity data export error',
      message: 'It seems that there was a problem exporting the data and your request could not be completed.'
    },
    cancel: {
      title: 'Cancel export',
      question: 'Do you want to cancel export process of <strong>{name}</strong>?',
      confirm: `Yes, cancel export`,
      continue: 'No, continue',
      notificationSuccess: 'Export canceled successfully.',
      notificationFailed: 'Failed to cancel export.'
    }
  },
  download: {
    parts: `{count} {count, plural,
      one {part}
      other {parts}
    }`,
    availableUntil: 'Available until: {date} at {hour}'
  },
  tilesets: {
    processingJobs: 'Processing jobs',
    error: {
      title: 'Tileset creation error',
      info: 'Error info',
      general: 'It seems that there was a problem creating the tileset and your request could not be completed.',
      access:
        "It seems your connection doesn't have enough permissions to create a table at the output destination (or it doesn't exist). Read more in our {documentationLink}",
      documentationLink: 'documentation'
    },
    query: 'Query',
    cancel: {
      title: 'Cancel processing job',
      question: 'Do you want to cancel this process?',
      confirm: 'Yes, cancel process',
      continue: 'No, continue'
    },
    nojobs: 'No jobs',
    running: 'Running:',
    tooltip: {
      success: 'View tileset'
    },
    status: {
      success: 'Tileset created successfully',
      failure: 'Tileset creation error. Read more',
      running: 'Creating tileset…'
    },
    customQuery: 'Custom Tileset creation'
  },
  datasets: {
    tooltip: {
      success: 'View dataset',
      warning: 'View import warnings'
    },
    status: {
      success: 'Imported successfully',
      successWithWarning: 'Imported with warnings',
      failure: 'Dataset creation error. Read more',
      failureInline: 'Import error',
      running: 'Importing...',
      runningInline: 'Importing to'
    },
    error: {
      title: 'Dataset creation error'
    },
    warning: {
      title: 'Import completed with warnings',
      info: 'Your data was imported, but some rows had problems:',
      // States the consequence, not a verdict on the data: the destination count
      // can't tell a geometry we failed to decode from one the source never had,
      // and a source with legitimately empty geometries is not broken. Holds for
      // both shapes of loss — a row dropped at parse time is equally absent from
      // a map. The reason in parentheses is what distinguishes them.
      droppedRows: "{droppedRows, plural, one {# row} other {# rows}} won't appear on maps ({reasons}).",
      droppedRowsNoReason: "{droppedRows, plural, one {# row} other {# rows}} won't appear on maps.",
      // The status can land a poll before its counters do; "0 rows" would be a
      // claim, "some rows" is what the status alone establishes.
      droppedRowsUncounted: "Some rows won't appear on maps ({reasons}).",
      droppedRowsUncountedNoReason: "Some rows won't appear on maps.",
      // Two loss classes, two sentences. locationLost rows ARE in the table —
      // only their geometry is gone; parse-dropped rows never made it at all.
      // Whole-sentence plural variants because the pronouns change too.
      locationLost:
        '{droppedRows, plural, one {# row was imported without location. Its coordinates could not be read.} other {# rows were imported without location. Their coordinates could not be read.}}',
      parseFailed:
        "{droppedRows, plural, one {# row} other {# rows}} couldn't be imported because of formatting errors.",
      reason: {
        invalidGeometry: 'invalid geometry',
        typeMismatch: 'type mismatch',
        parseError: 'parse error',
        other: 'other issues'
      }
    }
  },
  tabs: {
    imports: 'IMPORTS',
    na: 'N/A'
  },
  enrich: {
    status: {
      success: 'Table enriched successfully',
      failure: 'Enrich error. Read more',
      running: 'Enriching table…',
      runningInline: 'Enriching',
      failureInline: 'Enrich error'
    },
    tooltip: {
      success: 'View enriched table'
    },
    error: {
      title: 'Enriching table error',
      general: 'It seems that there was a problem enriching the table and your request could not be completed.',
      info: 'Error info',
      access:
        "It seems your connection doesn't have enough permissions to create a table at the output destination (or it doesn't exist). Read more in our {documentationLink}"
    },
    cancel: {
      title: 'Cancel data enrichment',
      question: 'Do you want to cancel data enrichment process?',
      confirm: 'Yes, cancel process',
      continue: 'No, continue'
    },
    customQuery: 'Custom Enrich creation'
  },
  import: {
    cancel: {
      title: 'Cancel data import',
      question: 'Do you want to cancel import process?',
      confirm: 'Yes, cancel import',
      continue: 'No, continue'
    }
  },
  atInstallation: {
    status: {
      success: 'Completed',
      failure: 'There was a problem during the installation process.',
      running: 'Installing'
    }
  },
  customQuery: 'Custom query'
}
